import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { getToken, clearToken } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { SignOut, SquaresFour, Drop } from "@phosphor-icons/react";
import { BrandMark } from "@/components/Brand";

export default function AdminLayout({ children, active = "leads" }) {
  const navigate = useNavigate();
  const token = getToken();

  useEffect(() => {
    if (!token) navigate("/admin/login", { replace: true });
  }, [token, navigate]);

  if (!token) return <Navigate to="/admin/login" replace />;

  const logout = () => {
    clearToken();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div
      className="min-h-screen w-full text-white"
      style={{ background: "var(--epx-bg)" }}
      data-testid="admin-layout"
    >
      <header
        className="border-b sticky top-0 z-30 backdrop-blur-md"
        style={{
          background: "rgba(10,11,12,0.85)",
          borderColor: "var(--epx-border)",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
          <BrandMark size="sm" />
          <nav className="flex items-center gap-1">
            <TabLink
              to="/admin"
              active={active === "leads"}
              icon={SquaresFour}
              label="Leads"
              testId="nav-leads"
            />
            <TabLink
              to="/admin/flakes"
              active={active === "flakes"}
              icon={Drop}
              label="Flakes"
              testId="nav-flakes"
            />
            <Button
              variant="ghost"
              onClick={logout}
              className="text-zinc-300 hover:text-white hover:bg-white/5 ml-2"
              data-testid="logout-button"
            >
              <SignOut size={16} className="mr-1.5" /> Sign out
            </Button>
          </nav>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
}

function TabLink({ to, active, icon: Icon, label, testId }) {
  return (
    <a
      href={to}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
        active
          ? "text-white"
          : "text-zinc-400 hover:text-white hover:bg-white/5"
      }`}
      style={
        active
          ? {
              background: "var(--epx-primary)",
              boxShadow: "0 0 16px rgba(var(--epx-primary-rgb),0.40)",
            }
          : undefined
      }
      data-testid={testId}
    >
      <Icon size={15} weight={active ? "fill" : "regular"} /> {label}
    </a>
  );
}
